export default [
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  // {
  //   path: "/users/list",
  //   name: "users-list",
  //   component: () => import("@/views/apps/user/users-list/UsersList.vue"),
  // },
  // {
  //   path: "/users/create-account",
  //   name: "users-create-account",
  //   component: () =>
  //     import("@/views/apps/user/create-account/CreateAccount.vue"),
  //   meta: {
  //     pageTitle: "Create User",
  //     breadcrumb: [
  //       {
  //         to: { name: "users-list" },
  //         text: "List Users",
  //       },
  //       {
  //         text: "Create User",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: "/users/view/:id",
  //   name: "users-view",
  //   component: () => import("@/views/apps/user/users-view/UsersView.vue"),
  //   meta: {
  //     pageTitle: "User Details",
  //     breadcrumb: [
  //       {
  //         to: { name: "users-list" },
  //         text: "List Users",
  //       },
  //       {
  //         text: "User Details",
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  {
    path: "/customers",
    name: "customers",
    component: () =>
      import("@/views/apps/customers/customer-list/CustomerList.vue"),
  },
  {
    path: "/customers/view/:id",
    name: "customers-view",
    component: () =>
      import("@/views/apps/customers/customer-view/CustomerView.vue"),
    // meta: {
    //   pageTitle: "Customer Details",
    //   breadcrumb: [
    //     {
    //       to: { name: "customers" },
    //       text: "List Customer",
    //     },
    //     {
    //       text: "Customer Details",
    //       active: true,
    //     },
    //   ],
    // },
  },

  {
    path: "/customers/create-account",
    name: "customers-create-account",
    component: () =>
      import("@/views/apps/user/create-account/CreateAccount.vue"),
    meta: {
      pageTitle: "Create Customer",
      breadcrumb: [
        {
          to: { name: "customers" },
          text: "List Customer",
        },
        {
          text: "Create Customer",
          active: true,
        },
      ],
    },
  },

  {
    path: "/customers/edit/:id",
    name: "customers-edit",
    component: () =>
      import("@/views/apps/customers/customer-edit/CustomerEdit.vue"),
    meta: {
      pageTitle: "Customer Details",
      breadcrumb: [
        {
          to: { name: "customers" },
          text: "List Customer",
        },
        {
          text: "Customer Details",
          active: true,
        },
      ],
    },
  },
  {
    path: "/trading",
    name: "trading",
    component: () => import("@/views/apps/trading"),
  },
  {
    path: "/trading/tradings-management",
    name: "tradings-management",
    component: () => import("@/views/apps/trading-managament/index.vue"),
  },
  {
    path: "/trading/feed-mapping-workbench",
    name: "trading-mapping",
    component: () =>
      import("@/views/apps/trading-managament/trading-mapping/index.vue"),
  },
  {
    path: "/trading/trading-dashboard",
    name: "trading-dashboard",
    component: () => import("@/views/apps/trading/dashboard"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          to: { name: "trading" },
          text: "Trading",
        },
        {
          text: "Trader",
          active: true,
        },
      ],
      actionButton: {
        text: "Bet Monitor",
        icon: "MonitorIcon",
        variant: "outline-secondary",
        to: { name: "trading" },
      },
    },
  },
  {
    path: "/trading/racing",
    name: "trading-racing",
    component: () => import("@/views/apps/trading/racing"),
  },
  {
    path: "/trading/racing/view/:id",
    name: "trading-racing-view",
    component: () => import("@/views/apps/trading/racing/view"),
  },
  {
    path: "/trading/racing/edit/:id",
    name: "trading-racing-edit",
    component: () => import("@/views/apps/trading/racing/edit"),
  },
  {
    path: "/trading/sports",
    name: "trading-sports",
    component: () => import("@/views/apps/trading/sports"),
  },
  {
    path: "/trading/sports/view/:id",
    name: "trading-sports-view",
    component: () => import("@/views/apps/trading/sports/create-sport"),
  },
  {
    path: "/trading/sports/create",
    name: "trading-sports-create",
    component: () => import("@/views/apps/trading/sports/create-sport"),
  },
  {
    path: "/trading/sports/:code/:id",
    name: "trading-sports-view",
    component: () => import("@/views/apps/trading/sports/create-sport"),
  },
  {
    path: "/trading/sports/:id/leagues/create",
    name: "trading-sports-league-create",
    component: () => import("@/views/apps/trading/sports/create-league"),
  },
  {
    path: "/trading/sports/:id/leagues/:leagueId",
    name: "trading-sports-league-edit",
    component: () => import("@/views/apps/trading/sports/create-league"),
  },
  {
    path: "/trading/sports/:code/:id/leagues/create",
    name: "trading-sports-league-create",
    component: () => import("@/views/apps/trading/sports/create-league"),
  },
  {
    path: "/trading/sports/:code/:id/leagues/:leagueId",
    name: "trading-sports-league-edit-back-to-sport",
    component: () => import("@/views/apps/trading/sports/create-league"),
  },
  {
    path: "/trading/sports/:code/leagues/:name/:id/events/create",
    name: "trading-sports-event-create-back-to-sport",
    component: () => import("@/views/apps/trading/sports/create-event"),
  },
  {
    path: "/trading/sports-config",
    name: "trading-sports-config",
    component: () =>
      import(
        "@/views/apps/trading-managament/lsport-managament/LeagueIgnoreConfig.vue"
      ),
  },
  {
    path: "/marketing",
    name: "marketing",
    component: () => import("@/views/apps/marketing/index.vue"),
  },
  {
    path: "/marketing/banners",
    name: "marketing-banners",
    component: () => import("@/views/apps/marketing/BannerManagement/List"),
  },
  {
    path: "/marketing/banners/new",
    name: "marketing-banners-new",
    component: () => import("@/views/apps/marketing/BannerManagement/Create"),
  },
  {
    path: "/marketing/banners/:id",
    name: "marketing-banners-detail",
    component: () => import("@/views/apps/marketing/BannerManagement/Detail"),
  },
  {
    path: "/marketing/sms-campaigns",
    name: "marketing-sms-campaigns",
    component: () => import("@/views/apps/marketing/SMSCampaign/List"),
  },
  {
    path: "/marketing/sms-campaigns/new",
    name: "marketing-sms-campaigns-new",
    component: () => import("@/views/apps/marketing/SMSCampaign/Create"),
  },
  {
    path: "/marketing/push-notifications",
    name: "marketing-push-notifications",
    component: () => import("@/views/apps/marketing/PushNotification/List"),
  },
  {
    path: "/marketing/push-notifications/new",
    name: "marketing-push-notifications-new",
    component: () => import("@/views/apps/marketing/PushNotification/Create"),
  },
  {
    path: "/marketing/in-app-messaging",
    name: "marketing-in-app-messaging",
    component: () => import("@/views/apps/marketing/InAppMessaging/List"),
  },
  {
    path: "/marketing/in-app-messaging/new",
    name: "marketing-in-app-messaging-new",
    component: () => import("@/views/apps/marketing/InAppMessaging/Create"),
  },
  {
    path: "/marketing/segments-customer",
    name: "marketing-customer-segments",
    component: () => import("@/views/apps/marketing/CustomerSegment/List"),
  },
  {
    path: "/marketing/segments-customer/new",
    name: "marketing-customer-segments-new",
    component: () => import("@/views/apps/marketing/CustomerSegment/Create"),
  },
  {
    path: "/marketing/segments-customer/:id",
    name: "marketing-customer-segments-new",
    component: () => import("@/views/apps/marketing/CustomerSegment/Create"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/apps/settings/SettingOverview.vue"),
  },
  {
    path: "/settings/user-management",
    name: "settings-user-management",
    component: () =>
      // import("@/views/apps/roles-permissions/user-list/UserList.vue"),
      import("@/views/apps/settings/SettingsPage.vue"),
  },
  {
    path: "/settings/profiles-and-betting-templates",
    name: "settings-customer-profiles-and-betting-templates",
    component: () =>
      // import("@/views/apps/roles-permissions/user-list/UserList.vue"),
      import("@/views/apps/settings/customer-profile-and-betting-template"),
  },
  {
    path: "/settings/profiles-and-betting-templates/create",
    name: "settings-create-betting-template",
    component: () =>
      import("@/views/apps/settings/customer-profile-and-betting-template/CreateTemplate"),
  },
  {
    path: "/settings/profiles-and-betting-templates/view-all",
    name: "settings-betting-template-list",
    component: () =>
      import("@/views/apps/settings/customer-profile-and-betting-template/TemplateList"),
  },
  {
    path: "/settings/system-configuration",
    name: "settings-system-configuration",
    component: () =>
      // import("@/views/apps/roles-permissions/user-list/UserList.vue"),
      import("@/views/apps/settings/system-configuration"),
  },
  {
    path: "/settings/security-and-compliance",
    name: "settings-security-and-compliance",
    component: () => import("@/views/apps/settings/security-and-compliance"),
  },
  {
    path: "/settings/notifications",
    name: "settings-notifications",
    component: () => import("@/views/apps/settings/notification-settings"),
  },
  {
    path: "/settings/marketing-and-promo",
    name: "settings-marketing-and-promo",
    component: () => import("@/views/apps/settings/marketing-and-promo"),
  },
  {
    path: "/promotions",
    name: "promotions",
    component: () => import("@/views/apps/promotions/index.vue"),
  },
  {
    path: "/promotions/odd-boost",
    name: "promotions/odd-boost",
    component: () => import("@/views/apps/promotions/OddBoost/List"),
  },
  {
    path: "/promotions/odd-boost/new",
    name: "promotions-odd-boost-new",
    component: () => import("@/views/apps/promotions/OddBoost/Create"),
  },
  {
    path: "/promotions/odd-boost/:id",
    name: "promotions-odd-boost-edit",
    component: () => import("@/views/apps/promotions/OddBoost/Create"),
  },
  {
    path: "/promotions/price-promotions",
    name: "promotions-price-promotions",
    component: () => import("@/views/apps/promotions/PricePromotions/List"),
  },
  {
    path: "/promotions/price-promotions/new",
    name: "promotions-price-promotions-new",
    component: () => import("@/views/apps/promotions/PricePromotions/Create"),
  },
  {
    path: "/promotions/price-promotions/:userId/new",
    name: "promotions-price-promotions-new",
    component: () => import("@/views/apps/promotions/PricePromotions/Create"),
  },
  {
    path: "/promotions/price-promotions/:id",
    name: "promotions-price-promotions-edit",
    component: () => import("@/views/apps/promotions/PricePromotions/Detail"),
  },
  {
    path: "/promotions/deposit-match",
    name: "promotions/deposit-match",
    component: () => import("@/views/apps/promotions/DepositMatch/List"),
  },
  {
    path: "/promotions/deposit-match/new",
    name: "promotions-deposit-match-new",
    component: () => import("@/views/apps/promotions/DepositMatch/Create"),
  },
  {
    path: "/promotions/deposit-match/:id",
    name: "promotions-deposit-match-edit",
    component: () => import("@/views/apps/promotions/DepositMatch/Create"),
  },
  {
    path: "/promotions/money-back-specials",
    name: "promotions/money-back-specials",
    component: () => import("@/views/apps/promotions/MoneyBackSpecial/List"),
  },
  {
    path: "/promotions/money-back-specials/new",
    name: "promotions-money-back-specials-new",
    component: () => import("@/views/apps/promotions/MoneyBackSpecial/Create"),
  },
  {
    path: "/promotions/money-back-specials/:userId/new",
    name: "promotions-money-back-specials-new",
    component: () => import("@/views/apps/promotions/MoneyBackSpecial/Create"),
  },
  {
    path: "/promotions/money-back-specials/:id",
    name: "promotions-money-back-specials-edit",
    component: () => import("@/views/apps/promotions/MoneyBackSpecial/Create"),
  },
  {
    path: "/promotions/game",
    name: "promotions-game",
    component: () => import("@/views/apps/promotions/Game/List"),
  },
  {
    path: "/promotions/game/new",
    name: "promotions-game-new",
    component: () => import("@/views/apps/promotions/Game/Create"),
  },
  {
    path: "/promotions/game/:id",
    name: "promotions-game-edit",
    component: () => import("@/views/apps/promotions/Game/Create"),
  },
  {
    path: "/finance",
    name: "finance",
    component: () => import("@/views/apps/finance"),
  },
  {
    path: "/bdm",
    name: "bdm",
    component: () => import("@/views/apps/bdm"),
  },
  {
    path: "/bdm-profile",
    name: "bdm-profile",
    component: () => import("@/views/apps/bdm/Profile/index.vue"),
  },
  {
    path: "/report",
    name: "report",
    redirect: "/report/betting/unresolved-liability",
  },
  {
    path: "/report/regulatory/all",
    name: "report-regulatory-all",
    component: () => import("@/views/apps/report/regulatory/All"),
  },
  {
    path: "/report/regulatory/racing",
    name: "report-regulatory-racing",
    component: () => import("@/views/apps/report/regulatory/Racing"),
  },
  {
    path: "/report/betting",
    name: "report-betting",
    component: () => import("@/views/apps/report/betting/AllBet"),
  },
  {
    path: "/report/betting/daily",
    name: "report-betting-daily",
    component: () => import("@/views/apps/report/betting/Daily"),
  },
  {
    path: "/report/betting/racing",
    name: "report-betting-racing",
    component: () => import("@/views/apps/report/betting/Racing"),
  },
  {
    path: "/report/betting/sports",
    name: "report-betting-sports",
    component: () => import("@/views/apps/report/betting/Sport"),
  },
  {
    path: "/report/financial/ggr",
    name: "report-financial-ggr",
    component: () => import("@/views/apps/report/financial/GGR"),
  },
  {
    path: "/report/financial/ngr",
    name: "report-financial-ngr",
    component: () => import("@/views/apps/report/financial/NGR"),
  },
  {
    path: "/report/financial/turnover",
    name: "report-financial-turnover",
    component: () => import("@/views/apps/report/financial/Turnover"),
  },
  {
    path: "/report/performance/bdm",
    name: "report-performance-bdm",
    component: () => import("@/views/apps/report/performance/BDM"),
  },
  {
    path: "/report/performance/affiliate",
    name: "report-performance-affiliate",
    component: () => import("@/views/apps/report/performance/Affiliate"),
  },
  {
    path: "/report/performance/customer",
    name: "report-performance-customer",
    component: () => import("@/views/apps/report/performance/Customer"),
  },
  {
    path: "/report/system/scheduled",
    name: "report-system-scheduled",
    component: () => import("@/views/apps/report/System/Schedule"),
  },
  {
    path: "/report/system/custom",
    name: "report-system-custom",
    component: () => import("@/views/apps/report/System/Custom"),
  },
  // *===============================================---*
  // *--------- NEW REPORTING ENDPOINTS ---------------*
  // *===============================================---*
  // Financial Reports
  {
    path: "/report/financial/upcoming-break-expiries",
    name: "report-financial-upcoming-break-expiries",
    component: () =>
      import("@/views/apps/report/financial/UpcomingBreakExpiries"),
    meta: {
      pageTitle: "Upcoming Break Expiries",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "Upcoming Break Expiries",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/financial/250k-plus-deposits",
    name: "report-financial-250k-plus-deposits",
    component: () =>
      import("@/views/apps/report/financial/Deposits250kPlus"),
    meta: {
      pageTitle: "250k+ Deposits (AML)",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "250k+ Deposits",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/financial/user-balances-at-date",
    name: "report-financial-user-balances-at-date",
    component: () =>
      import("@/views/apps/report/financial/UserBalancesAtDate"),
    meta: {
      pageTitle: "User Balances at Date",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "User Balances at Date",
          active: true,
        },
      ],
    },
  },
  // Betting Reports
  {
    path: "/report/betting/unresolved-liability",
    name: "report-betting-unresolved-liability",
    component: () =>
      import("@/views/apps/report/betting/UnresolvedLiability"),
    meta: {
      pageTitle: "Unresolved Liability",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "Unresolved Liability",
          active: true,
        },
      ],
    },
  },
  // Performance Reports
  {
    path: "/report/performance/bdm-bonus-bets",
    name: "report-performance-bdm-bonus-bets",
    component: () => import("@/views/apps/report/performance/BdmBonusBets"),
    meta: {
      pageTitle: "BDM Bonus Bets",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "BDM Bonus Bets",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/performance/product-profitability",
    name: "report-performance-product-profitability",
    component: () =>
      import("@/views/apps/report/performance/ProductProfitability"),
    meta: {
      pageTitle: "Product Profitability",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "Product Profitability",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/performance/bonus-ggr-by-user",
    name: "report-performance-bonus-ggr-by-user",
    component: () =>
      import("@/views/apps/report/performance/BonusGgrByUser"),
    meta: {
      pageTitle: "Bonus GGR by User",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "Bonus GGR by User",
          active: true,
        },
      ],
    },
  },
  // System Reports
  {
    path: "/report/system/user-transaction-history",
    name: "report-system-user-transaction-history",
    component: () =>
      import("@/views/apps/report/System/UserTransactionHistory"),
    meta: {
      pageTitle: "User Transaction History",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "User Transaction History",
          active: true,
        },
      ],
    },
  },
  {
    path: "/report/system/bdm-birthdays-today",
    name: "report-system-bdm-birthdays-today",
    component: () =>
      import("@/views/apps/report/System/BdmBirthdaysToday"),
    meta: {
      pageTitle: "BDM Birthdays Today",
      breadcrumb: [
        {
          to: { name: "report" },
          text: "Reports",
        },
        {
          text: "BDM Birthdays Today",
          active: true,
        },
      ],
    },
  },
];
